export const GOAL_FIELDS = [
  { key: 'target_calories', unit: 'kcal' },
  { key: 'target_protein_g', unit: 'g' },
  { key: 'target_carbs_g', unit: 'g' },
  { key: 'target_carbs_training_day_g', unit: 'g' },
  { key: 'target_fat_g', unit: 'g' },
  { key: 'target_fiber_g', unit: 'g' },
  { key: 'target_weight_kg', unit: 'kg' },
]
